import { render, staticRenderFns } from "./RouterInputItem.vue?vue&type=template&id=e60f04d2&scoped=true"
import script from "./RouterInputItem.vue?vue&type=script&lang=js"
export * from "./RouterInputItem.vue?vue&type=script&lang=js"
import style0 from "./RouterInputItem.vue?vue&type=style&index=0&id=e60f04d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60f04d2",
  null
  
)

export default component.exports